import { useQuery } from '@apollo/client';
import { Button } from '@otp/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'src/components/common/link';
import { Pagination } from 'src/components/common/list/pagination';
import { Routes } from 'src/components/common/router/constants';
import { WttpQuestionnaireCard } from 'src/components/wttp/questionnaire-responses/list/card/card';
import { Filter } from 'src/components/wttp/questionnaire-responses/list/filter';
import {
  SortingDirection,
  StoreModel,
  WttpQuestionnaireResponsesDocument,
  WttpQuestionnaireResponsesQuery,
  WttpQuestionnairesListFilterInput,
} from 'src/graphql/generated/graphql';
import { useTable } from 'src/hooks/use-table';

const PAGINATION_LIMIT = 5;

const OMIT_FILTER_OPTIONS = ['storeIds'];

type RestaurantWttpProps = {
  store: Partial<StoreModel>;
};

export const RestaurantWttp = ({ store }: RestaurantWttpProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'issue.ticket.list.preview',
  });

  const [totalCount, setTotalCount] = useState(0);

  const { page, setPage, filter, onFilterChange } = useTable<
    WttpQuestionnairesListFilterInput,
    Record<string, SortingDirection>
  >();

  const combinedFilter = {
    ...filter,
    isActive: true,
    storeIds: [store.id],
  };

  const { data } = useQuery<WttpQuestionnaireResponsesQuery>(
    WttpQuestionnaireResponsesDocument,
    {
      variables: {
        filter: combinedFilter,
        pagination: {
          limit: PAGINATION_LIMIT,
          offset: page * PAGINATION_LIMIT,
        },
        sorting: {
          updatedAt: SortingDirection.Desc,
        },
      },
      onCompleted: (data) =>
        setTotalCount(data?.wttpQuestionnaireResponses.pagination.totalCount),
    },
  );

  const questionnaireResponses = data?.wttpQuestionnaireResponses.records || [];

  return (
    <div>
      <Filter
        onSubmit={onFilterChange}
        omitFilterOptions={OMIT_FILTER_OPTIONS}
      />
      <Pagination
        onPageChange={setPage}
        count={totalCount}
        rowsPerPage={PAGINATION_LIMIT}
        page={page}
      />
      {questionnaireResponses.length > 0 && (
        <div>
          {questionnaireResponses?.map((questionnaireResponse) => (
            <WttpQuestionnaireCard
              key={questionnaireResponse.id}
              questionnaireResponse={questionnaireResponse}
              buttonVariant="icon"
            />
          ))}
          <Link
            to={Routes.wttpQuestionnaireResponses.path}
            queryParams={{ filter: combinedFilter }}
            className="float-right"
          >
            <Button>{t('see-all')}</Button>
          </Link>
        </div>
      )}
    </div>
  );
};
